import { HttpService } from '../../../../common/api/httpService';
import { BalanceGroup, BalanceHistoryItemDto, BalanceHistoryRequest } from '../../../../models/balance';
import {RequestResultValue} from "../../../../common/api/requestResult";

export class BalanceApi {
    private static httpService = HttpService.getInstance();

    static async getHistory(request: BalanceHistoryRequest): Promise<RequestResultValue<BalanceHistoryItemDto[]>> {
        const result = await this.httpService.adminFetch('balanceHistory/list', 'POST', request);
        if (result.result && result.value) {
            return new RequestResultValue<BalanceHistoryItemDto[]>(true, result.value as BalanceHistoryItemDto[]);
        }
        return new RequestResultValue<BalanceHistoryItemDto[]>(false);
    }
}

export { BalanceGroup };



